import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					title={"Enable WA"}
					image={require('./video.jpg')}
					// video={{ mp4: require('../../ContactUs/video.mp4'), webm: require('../../ContactUs/video.webm')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">An iconic local social services provider looking to celebrate.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/enable-wa.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing consultancy together with a a new online presence (adhering to strict accessibility requirements), video production and digital marketing to promote their successes.</div>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Website <a href="https://www.enablewa.org.au">www.enablewa.org.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Fully accessible design to WCAG2.0 standards</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Video Production</li>
									<li>Google Adwords and Facebook Advertising Campaigns</li>
									<li>Graphic Design – Posters, Flyers, Pull Up Banners, etc</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Enable WA Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Enable WA Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Enable WA Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Enable WA Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/EnableWA/index.js